import React, { useState, useEffect, useMemo, useRef } from "react";
import { useParams } from "react-router-dom";
import item1 from "../Assets/milk.jpg";
import {
  ArrowLeft,
  Phone,
  Mic,
  Bike,
  Copy,
  MapPin,
  CheckCircle,
  ArrowRight,
  Check,
  ChevronDown,
  ChevronUp,
  ShieldCheck,
  ArrowDown,
  HelpCircle,
  ClipboardList,
  ThumbsUp,
  Bell,
  Maximize2,
  Minimize2,
  BellOff,
  Shield,
  Clock,
  StickyNote,
  Timer,
  Utensils,
} from "lucide-react";

import {
  MapContainer,
  TileLayer,
  Marker,
  Polyline,
  useMap,
  Popup,
} from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

import banner1 from "../Assets/banner_1.webp";
import banner2 from "../Assets/banner_2.webp";
import driver from "../Assets/driver.jpg";
import home from "../Assets/Home_icon.svg";
import resturant from "../Assets/Resturant_icon.svg";
import deliveryman from "../Assets/delivery man 512 x 512.svg";
import { toast } from "sonner";
import axios from "axios";
import * as signalR from "@microsoft/signalr";

function FitBounds({ bounds }) {
  const map = useMap();
  const lastBoundsRef = useRef(null);

  useEffect(() => {
    if (!map) return;
    if (!bounds || bounds.length === 0) return;

    // prevent unnecessary fitBounds
    const sameAsLast =
      JSON.stringify(lastBoundsRef.current) === JSON.stringify(bounds);

    if (sameAsLast) return;

    lastBoundsRef.current = bounds;

    const timeout = setTimeout(() => {
      try {
        if (bounds.length === 1) {
          map.setView(bounds[0], map.getZoom());
        } else {
          map.fitBounds(bounds, { padding: [30, 30] });
        }
      } catch (e) {
        console.warn("FitBounds skipped", e);
      }
    }, 200);

    return () => clearTimeout(timeout);
  }, [bounds, map]);

  return null;
}

export default function OrderTracking() {
  const [copied, setCopied] = useState(false);
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);
  const [showSafety, setShowSafety] = useState(false);
  const [showStickyHeader, setShowStickyHeader] = useState(false);
  const mapRef = useRef(null);
  const [expand, setExpand] = useState(false);
  const [manualExpand, setManualExpand] = useState(false);
  const baseImages = [banner1, banner2];

  const [baseurl] = useState("https://api2.packky.com");
  const username = "packky@gmail.com";
  const password = "Z90LTO34RTNQGT49LCIYRVTXJERZTKX8";
  const token = btoa(`${username}:${password}`);

  const [driverLoading, setDriverLoading] = useState(false);
  const [isUnauthorised, setIsUnauthorised] = useState(false);
  const [driverApiData, setDriverApiData] = useState(null);
  const [orderDetails, setOrderDetails] = useState(null);
  const [products, setProducts] = useState([]);
  const [total, setTotal] = useState(0);

  const [trackerUrl, setTrackerUrl] = useState(null);
  const [deliveryInstruction, setDeliveryInstruction] = useState(null);
  const [instructionOpen, setInstructionOpen] = useState(false);
  const [pageAllowed, setPageAllowed] = useState(null);
  const [customInstruction, setCustomInstruction] = useState("");
  const [selectedInstruction, setSelectedInstruction] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [driverRating, setDriverRating] = useState("");
  const [customerMessage, setCustomerMessage] = useState("");
  const [ratingSubmitting, setRatingSubmitting] = useState(false);
  const [ratingSubmitted, setRatingSubmitted] = useState(false);
  const [instructionSubmitted, setInstructionSubmitted] = useState(false);
  const [submittedInstruction, setSubmittedInstruction] = useState(null);
const [orderSummaryLoaded, setOrderSummaryLoaded] = useState(false);
const [remainingTime, setRemainingTime] = useState(null);

  const [pricing, setPricing] = useState({
    subTotal: 0,
    cgst: 0,
    sgst: 0,
    total: 0,
    paymentMode: "",
  });

  const { taskId: rawParam } = useParams();

  const [taskId, orderId] = useMemo(() => {
    if (!rawParam) return [null, null];

    const parts = rawParam.split("-");

    if (parts.length < 2) return [null, null];
    return [parts[0], parts[1]];
  }, [rawParam]);

  const [driverPosition, setDriverPosition] = useState(null);
  const [routePath, setRoutePath] = useState([]);
  const [rotation, setRotation] = useState(0);
  const prevPositionRef = useRef(null);

  const loopedImages = Array.from({ length: 40 }, (_, i) => {
    return baseImages[i % baseImages.length];
  });

  const iconMap = {
    Bike: <Bike size={18} />,
    MapPin: <MapPin size={18} />,
    Phone: <Phone size={18} />,
    note: <StickyNote size={20} />,
    shield: <Shield size={18} />,
    bellOff: <BellOff size={18} />,
    phone: <Phone size={18} />,
    mapPin: <MapPin size={18} />,
    clock: <Clock size={18} />,
  };

  const driverStatus = driverApiData?.driver_status?.toLowerCase();
  const merchantStatus = orderDetails?.merchant_status?.toLowerCase();

  const driverStatusMeta = useMemo(() => {
    if (driverStatus === "arrived") {
      return {
        message: "Driver arrived at restaurant",
        color: "text-orange-700",
      };
    }

    if (driverStatus === "acknowledged") {
      return {
        message: "Driver accepted your order",
        color: "text-indigo-600",
      };
    }

    if (driverStatus === "assigned") {
      return {
        message: "Driver assigned successfully",
        color: "text-blue-600",
      };
    }

    if (driverStatus === "successful") {
      return {
        message: "Order delivered successfully",
        color: "text-green-600",
      };
    }

    if (merchantStatus === "food is ready") {
      return {
        message: "Driver is on the way",
        color: "text-orange-600",
      };
    }

    if (!driverStatus && merchantStatus === "unassigned") {
      return {
        message: "Driver search in priority base",
        color: "text-gray-500",
      };
    }

    return {
      message: "Waiting for assignment",
      color: "text-gray-500",
    };
  }, [driverStatus, merchantStatus]);

  const driverData = {
    name: driverApiData?.driver_name || "Delivery Partner",
    image: driverApiData?.driver_image || driver,
    phone: driverApiData?.diver_mobile_number,

    latitude: driverApiData?.drvier_latitude
      ? Number(driverApiData.drvier_latitude)
      : null,

    longitude: driverApiData?.driver_longitude
      ? Number(driverApiData.driver_longitude)
      : null,

    message: driverStatusMeta.message,
    statusColor: driverStatusMeta.color,
  };

const fetchDriver = async () => {
  if (!taskId) return;

  try {
    const res = await axios.post(
      `${baseurl}/api/DriverTracker/v1.0/getDeliveryPartnerDetails`,
      { taskId },
      { headers: { Authorization: `Basic ${token}` } }
    );

    if (res?.data?.responseCode === "00") {
      const driver = res.data.data?.[0];
      if (!driver) return;

      setDriverApiData(driver);

      // 📍 Location
      if (driver.drvier_latitude && driver.driver_longitude) {
        setDriverPosition([
          Number(driver.drvier_latitude),
          Number(driver.driver_longitude),
        ]);
      }

      // ⏱ Remaining Time
      if (driver.remaining_time !== null) {
        const time = Number(driver.remaining_time);
        if (!isNaN(time)) {
          setRemainingTime(time);
        }
      }
    }
  } catch (err) {
    console.error("fetchDriver error:", err);
  }
};

  const fetchResturantDetails = async () => {
    if (!taskId) return;

    try {
      const res = await axios.post(
        `${baseurl}/api/DriverTracker/v1.0/getRestaurantOrderDetails`,
        { taskId },
        {
          headers: { Authorization: `Basic ${token}` },
        },
      );

      if (res?.data?.responseCode === "00") {
        setOrderDetails(res.data.data);
      }
    } catch (err) {
      toast.error("Failed to fetch order details");
    }
  };

  const fetchOrderDetails = async () => {
    if (!taskId) return;

    try {
      const res = await axios.post(
        `${baseurl}/api/DriverTracker/v1.0/getDeliveryOrderItems`,
        { taskId },
        {
          headers: {
            Authorization: `Basic ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      // ❌ NO DATA
      if (res?.data?.responseCode !== "00") {
        setProducts([]);
        setPricing({
          subTotal: 0,
          cgst: 0,
          sgst: 0,
          total: 0,
          paymentMode: "",
        });
        return;
      }

      const orderArray = res.data.data || [];
      if (!orderArray.length) return;

      const matchedOrder = orderArray.find(
        (order) => String(order.task_id) === String(taskId),
      );

      if (!matchedOrder) return;

      /* ================= PRICING ================= */
      setPricing({
        subTotal: Number(matchedOrder.sub_total || 0),
        cgst: Number(matchedOrder.cgst || 0),
        sgst: Number(matchedOrder.sgst || 0),
        total: Number(matchedOrder.total || 0),
        paymentMode: matchedOrder.payment_mode || "Online",
      });

      /* ================= PRODUCTS ================= */
      const formattedProducts =
        matchedOrder.order_details?.items?.map((item, index) => ({
          id: index + 1,
          name: item.itemName,
          qty: Number(item.quantity || 0),
          unitPrice: Number(item.unitPrice || 0),
          itemTotal: Number(item.total || 0),
          image: "/placeholder.png",
        })) || [];

      setProducts(formattedProducts);
    } catch (error) {
      console.error("Order details fetch error:", error);
    }
  };

  const fetchDeliveryInstructions = async () => {
    try {
      const res = await axios.post(
        `${baseurl}/api/DriverTracker/v1.0/getDeliveryInstructions`,
        { status: "Y" },
        {
          headers: { Authorization: `Basic ${token}` },
        },
      );

      if (res?.data?.responseCode === "00") {
        const list = res.data.data || [];

        if (!list.length) {
          setDeliveryInstruction(null);
          return;
        }

        const mappedData = {
          header: {
            icon: "note",
            title: list[0]?.title || "Delivery Instructions",
            subtitle:
              list[0]?.description ||
              "Customer’s special instructions for the delivery partner",
          },

          sections: list.slice(1).map((item) => ({
            id: item.pk_instruction_id,
            // icon: "shield",
            title: item.title,
            description: item.description,
          })),
        };

        setDeliveryInstruction(mappedData);
      }
    } catch (err) {
      console.error("Delivery instruction API error", err);
    }
  };

  const handleSubmitInstruction = async () => {
    if (!customInstruction && !selectedInstruction) {
      toast.error("Please add or select an instruction");
      return;
    }

    const payload = {
      taskId: String(taskId),
      instructionId: selectedInstruction ? String(selectedInstruction) : "",
      extraMessege: customInstruction || "",
    };

    try {
      setSubmitting(true);

      await axios.post(
        `${baseurl}/api/DriverTracker/v1.0/insertCustomerDeliveryInstructions`,
        payload,
        {
          headers: {
            Authorization: `Basic ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      const selectedItem = deliveryInstruction?.sections.find(
        (i) => i.id === selectedInstruction,
      );

      setSubmittedInstruction({
        title: selectedItem?.title || "Custom instruction",
        message: customInstruction || selectedItem?.description || "",
      });

      setInstructionSubmitted(true);
      setInstructionOpen(false);
      setSelectedInstruction(null);
      setCustomInstruction("");

      toast.success("Delivery instructions submitted");
    } catch (err) {
      toast.error("Failed to submit instructions");
    } finally {
      setSubmitting(false);
    }
  };

  const submitDeliveryRating = async () => {
    if (!driverRating) {
      toast.error("Please select rating");
      return;
    }

    const payload = {
      taskId: String(taskId),
      customerName: orderDetails?.customer_name || "",
      customerMobile: orderDetails?.customer_name || "",
      driverRating: String(driverRating),
      customerMessege: customerMessage,
    };

    try {
      setRatingSubmitting(true);

      const res = await axios.post(
        `${baseurl}/api/DriverTracker/v1.0/insertTaskDeliveryRating`,
        payload,
        {
          headers: {
            Authorization: `Basic ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      if (res?.data?.responseCode === "00") {
        toast.success("Thank you for your feedback ");
        setRatingSubmitted(true);
      } else {
        toast.error("Failed to submit rating");
      }
    } catch (err) {
      console.error("Rating API error", err);
      toast.error("Something went wrong");
    } finally {
      setRatingSubmitting(false);
    }
  };

  const showRatingSection =
    driverStatus === "successful" ||
    merchantStatus === "successful" ||
    merchantStatus === "delivered";
  const prevPosRef = useRef(null);

  useEffect(() => {
    if (driverApiData?.drvier_latitude && driverApiData?.driver_longitude) {
      const currentPos = [
        Number(driverApiData.drvier_latitude),
        Number(driverApiData.driver_longitude),
      ];

      console.log("CURRENT POSITION:", currentPos);

      if (prevPosRef.current) {
        const moved =
          prevPosRef.current[0] !== currentPos[0] ||
          prevPosRef.current[1] !== currentPos[1];

        console.log(moved ? "DRIVER MOVED" : "DRIVER NOT MOVED (STATIC)");
      }

      prevPosRef.current = currentPos;
      setDriverPosition(currentPos);
    }
  }, [driverApiData]);

  useEffect(() => {
    if (taskId) {
      console.log("TASKID", taskId);
      fetchDriver();
      fetchResturantDetails();
    } else {
    }
  }, [taskId]);

  // useEffect(() => {
  //   if (taskId) {
  //     console.log("order details:", taskId);
  //     fetchOrderDetails();
  //   }
  // }, [taskId]);

  // useEffect(() => {
  //   fetchDeliveryInstructions();
  // }, []);

  useEffect(() => {
  setOrderSummaryLoaded(false);
  setOpen(false);
}, [taskId]);

  useEffect(() => {
    if (!driverPosition) return;

    setRoutePath((prev) => {
      const last = prev[prev.length - 1];
      if (
        last &&
        last[0] === driverPosition[0] &&
        last[1] === driverPosition[1]
      ) {
        return prev;
      }
      return [...prev, driverPosition];
    });
  }, [driverPosition]);

  // driver icon Rotation
  const calculateBearing = (start, end) => {
    const toRad = (deg) => (deg * Math.PI) / 180;
    const toDeg = (rad) => (rad * 180) / Math.PI;

    const lat1 = toRad(start[0]);
    const lon1 = toRad(start[1]);
    const lat2 = toRad(end[0]);
    const lon2 = toRad(end[1]);

    const dLon = lon2 - lon1;

    const y = Math.sin(dLon) * Math.cos(lat2);
    const x =
      Math.cos(lat1) * Math.sin(lat2) -
      Math.sin(lat1) * Math.cos(lat2) * Math.cos(dLon);

    return (toDeg(Math.atan2(y, x)) + 360) % 360;
  };

  useEffect(() => {
    if (!driverPosition) return;

    if (prevPositionRef.current) {
      const angle = calculateBearing(prevPositionRef.current, driverPosition);
      setRotation(angle);
    }

    prevPositionRef.current = driverPosition;
  }, [driverPosition]);

  // new driver position
  useEffect(() => {
    if (!driverPosition) return;

    setRoutePath((prev) => {
      if (
        prev.length &&
        prev[prev.length - 1][0] === driverPosition[0] &&
        prev[prev.length - 1][1] === driverPosition[1]
      ) {
        return prev;
      }

      return [...prev, driverPosition];
    });
  }, [driverPosition]);

  // distance calculation
  const haversineDistance = (lat1, lon1, lat2, lon2) => {
    const R = 6371;
    const dLat = ((lat2 - lat1) * Math.PI) / 180;
    const dLon = ((lon2 - lon1) * Math.PI) / 180;

    const a =
      Math.sin(dLat / 2) ** 2 +
      Math.cos((lat1 * Math.PI) / 180) *
        Math.cos((lat2 * Math.PI) / 180) *
        Math.sin(dLon / 2) ** 2;

    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  };

  // ETA calculation (avg speeed 25km/h)
  const [eta, setEta] = useState(null);

  useEffect(() => {
    if (!driverPosition) return;

    const distance = haversineDistance(
      driverPosition[0],
      driverPosition[1],
      homeLat,
      homeLng,
    );

    const speed = 25; // km/h
    const timeMinutes = Math.round((distance / speed) * 60);

    setEta(timeMinutes);
  }, [driverPosition]);

  // Arrival detection
  const hasArrivedRef = useRef(false);

  useEffect(() => {
    if (!driverPosition || hasArrivedRef.current) return;

    const distance = haversineDistance(
      driverPosition[0],
      driverPosition[1],
      homeLat,
      homeLng,
    );

    if (distance < 0.05) {
      hasArrivedRef.current = true;
      toast.success(" Your delivery partner has arrived!");
    }
  }, [driverPosition]);

  const restaurantName = orderDetails?.merchant_name || "The restaurant";

  const formattedStoreDistance = useMemo(() => {
    if (!orderDetails?.distance) return null;

    const distanceMeters = Number(orderDetails.distance);

    if (isNaN(distanceMeters)) return null;

    if (distanceMeters < 1000) {
      return `${distanceMeters} m`;
    }

    return `${(distanceMeters / 1000).toFixed(2)} km`;
  }, [orderDetails]);

  const trackingText = useMemo(() => {
    if (driverStatus === "arrived") {
      return {
        sub: "Delivery partner reached restaurant",
        main: "Driver arrived at restaurant",
      };
    }

    if (driverStatus === "acknowledged") {
      return {
        sub: "Delivery partner accepted",
        main: "Driver accepted your order",
      };
    }

    if (driverStatus === "assigned") {
      return {
        sub: "Delivery partner assigned",
        main: "Driver assigned successfully",
      };
    }

    if (merchantStatus === "food is ready") {
      return {
        sub: "Order picked up from restaurant",
        main: "Driver is on the way",
      };
    }

    if (driverStatus === "successful") {
      return {
        sub: "Delivery completed",
        main: "Order delivered",
      };
    }

    if (!driverStatus && merchantStatus === "unassigned") {
      return {
        sub: "Finding the best delivery partner",
        main: "Driver search in priority base",
      };
    }

    return {
      sub: "Please wait while we process your order",
      main: "Preparing your order",
    };
  }, [driverStatus, merchantStatus]);

  const deliveryDetails = {
    header: {
      title: "Your delivery details",
      subtitle: "Details of your current order",
      icon: "Bike",
    },
    sections: [
      {
        id: "address",
        title: orderDetails?.customer_name || "Delivery at Home",
        description: orderDetails?.customer_address || "Fetching address...",
        icon: "MapPin",
      },
    ],
  };

  /*  SCROLL LOGIC */
  useEffect(() => {
    const onScroll = () => {
      const scrollY = window.scrollY;

      // Map auto expand/collapse ONLY if not manually expanded
      if (!manualExpand) {
        if (scrollY > 180) {
          setExpand(true);
        } else {
          setExpand(false);
        }
      }

      // HEADER logic – ALWAYS based on scroll
      if (scrollY > 180) {
        setShowStickyHeader(true);
      } else {
        setShowStickyHeader(false);
      }
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [manualExpand]);

  /*  CAROUSEL  */
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % loopedImages.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [loopedImages.length]);

  // const total = useMemo(
  //   () => products.reduce((sum, item) => sum + item.price * item.qty, 0),
  //   [products]
  // );

  const handleCopy = () => {
    navigator.clipboard.writeText(taskId);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  /* LEAFLET */
  const pickupLat = orderDetails?.merchant_latitude
    ? Number(orderDetails.merchant_latitude)
    : null;

  const pickupLng = orderDetails?.merchant_longitude
    ? Number(orderDetails.merchant_longitude)
    : null;

  const homeLat = orderDetails?.customer_latitude
    ? Number(orderDetails.customer_latitude)
    : null;

  const homeLng = orderDetails?.customer_longitude
    ? Number(orderDetails.customer_longitude)
    : null;

  const driverLat = driverPosition?.[0];
  const driverLng = driverPosition?.[1];

  const bounds = useMemo(() => {
    const points = [];

    if (Number.isFinite(pickupLat) && Number.isFinite(pickupLng))
      points.push([pickupLat, pickupLng]);

    if (Number.isFinite(driverLat) && Number.isFinite(driverLng))
      points.push([driverLat, driverLng]);

    if (Number.isFinite(homeLat) && Number.isFinite(homeLng))
      points.push([homeLat, homeLng]);

    return points;
  }, [pickupLat, pickupLng, driverLat, driverLng, homeLat, homeLng]);

  // const mapCenter = [(homeLat + driverLat) / 2, (homeLng + driverLng) / 2];

  const homeIcon = useMemo(() => {
    return L.divIcon({
      className: "",
      html: `
        <div style="
          width:38px;
          height:38px;
          background:#ffffff;
          border-radius:50%;
          display:flex;
          align-items:center;
          justify-content:center;
          border:1px solid #e5e7eb;
        ">
          <img src="${home}" style="width:18px;height:18px;" />
        </div>
    `,
      iconSize: [34, 34],
      iconAnchor: [19, 56],
    });
  }, []);

  const restaurantIcon = useMemo(() => {
    return L.divIcon({
      className: "",
      html: `
     <div style="
      display:flex;
      flex-direction:column;
      align-items:center;
    ">
      
      <!-- PIN BODY -->
      <div style="
        width:38px;
        height:38px;
        background:#ffffff;
        border-radius:50%;
        display:flex;
        align-items:center;
        justify-content:center;
        box-shadow:0 4px 10px rgba(0,0,0,0.25);
        border:1px solid #e5e7eb;
      ">
        <img 
          src="${resturant}" 
          style="width:18px;height:18px;"
        />
      </div>
    </div>
  `,
      iconSize: [34, 34],
      iconAnchor: [17, 34],
    });
  }, []);

  const driverIcon = useMemo(() => {
    return L.divIcon({
      className: "",
      html: `
      <img
        src="${deliveryman}"
        style="
          width:32px;
          height:32px;
          transform: rotate(${rotation}deg);
        "
      />
    `,
      iconSize: [32, 32],
      iconAnchor: [16, 32],
    });
  }, [rotation]);

  //  CURVE GENERATOR
  const generateCurve = (start, end, points = 20) => {
    if (!start || !end) return [];

    return Array.from({ length: points }, (_, i) => {
      const t = i / (points - 1);
      return [
        start[0] + (end[0] - start[0]) * t,
        start[1] + (end[1] - start[1]) * t + Math.sin(t * Math.PI) * 0.0004,
      ];
    });
  };

  const isDriverAssigned = useMemo(() => {
    if (merchantStatus === "unassigned") return false;

    return ["assigned", "acknowledged", "arrived", "successful"].includes(
      driverStatus,
    );
  }, [driverStatus, merchantStatus]);

  //  DERIVED FLAGS
  const hasDriverLocation =
  Number.isFinite(driverLat) && Number.isFinite(driverLng);

  const isFoodReady = merchantStatus === "food is ready";

  //  DUMMY DRIVER POSITION
  const dummyDriverPosition = useMemo(() => {
    if (!pickupLat || !pickupLng) return null;

    return [pickupLat + 0.0012, pickupLng + 0.001];
  }, [pickupLat, pickupLng]);

  const showDummyDriver = !hasDriverLocation;

  //  ROUTES
  const dummyRoute = useMemo(() => {
    if (!showDummyDriver || !dummyDriverPosition) return [];

    return generateCurve([pickupLat, pickupLng], dummyDriverPosition);
  }, [showDummyDriver, dummyDriverPosition, pickupLat, pickupLng]);

  const realRoute = useMemo(() => {
    if (!hasDriverLocation || !isFoodReady) return [];

    return generateCurve([pickupLat, pickupLng], [driverLat, driverLng]);
  }, [
    hasDriverLocation,
    isFoodReady,
    pickupLat,
    pickupLng,
    driverLat,
    driverLng,
  ]);

  useEffect(() => {
    if (!pickupLat || !pickupLng) return;

    setRoutePath((prev) => (prev.length ? prev : [[pickupLat, pickupLng]]));
  }, [pickupLat, pickupLng]);

  useEffect(() => {
    if (!mapRef.current) return;

    const map = mapRef.current;

    const timeout = setTimeout(() => {
      try {
        map.invalidateSize();
      } catch (e) {
        console.warn("invalidateSize skipped");
      }
    }, 300);

    return () => clearTimeout(timeout);
  }, [expand]);

  // Button click handler
  const handleMapToggle = () => {
    setManualExpand(!expand);
    setExpand(!expand);
  };

  // signal R

  const connectionRef = useRef(null);
const fetchDriverRef = useRef(fetchDriver);
const lastFetchRef = useRef(0);

useEffect(() => {
  fetchDriverRef.current = fetchDriver;
}, [fetchDriver]);

  useEffect(() => {
  if (!taskId) return;

  const connection = new signalR.HubConnectionBuilder()
    .withUrl(`${baseurl}/notificationHub`, {
      accessTokenFactory: () => token,
      transport: signalR.HttpTransportType.WebSockets,
    })
    .withAutomaticReconnect()
    .configureLogging(signalR.LogLevel.None)
    .build();

  connectionRef.current = connection;

  connection
    .start()
    .then(() => console.log("✅ SignalR Connected"))
    .catch((err) => console.error("❌ SignalR Connection Error:", err));

  connection.on("ReceiveStatusUpdate", (data) => {
    console.log("🔔 SignalR update received:", data);

    const now = Date.now();

    // ⛔ throttle (2 sec)
    if (now - lastFetchRef.current < 2000) return;

    lastFetchRef.current = now;

    console.log("🔄 Auto reload fetchDriver()");
    fetchDriverRef.current(); // ✅ ONLY API CALL
  });

  return () => {
    if (connectionRef.current) {
      connectionRef.current.off("ReceiveStatusUpdate");
      connectionRef.current.stop();
      console.log("🛑 SignalR Disconnected");
    }
  };
}, [taskId]);


const etaText = useMemo(() => {
  if (!Number.isFinite(remainingTime)) return null;

  if (remainingTime <= 0) {
    return { text: "Almost at your doorstep", color: "text-green-600" };
  }

  if (remainingTime <= 2) {
    return { text: "Delivery partner near you", color: "text-orange-600" };
  }

  return {
    text: `Arriving in ${remainingTime} min`,
    color: "text-gray-600",
  };
}, [remainingTime]);


  return (
    <div className="min-h-screen bg-gray-100 flex justify-center">
      <div className="w-full max-w-md bg-orange-100 relative">
        {/* CAROUSEL */}
        <div className="w-full max-w-md mx-auto relative">
          <button
            onClick={() =>
              setIndex((prev) =>
                prev === 0 ? loopedImages.length - 1 : prev - 1,
              )
            }
            className="absolute top-2 left-3 z-[1000] bg-white/90 backdrop-blur
             p-2 rounded-full shadow-md hover:bg-gray-100"
          >
            <ArrowLeft className="w-5 h-5 text-gray-700" />
          </button>
          <div className="overflow-hidden ">
            <div
              className="flex transition-transform duration-700 ease-in-out"
              style={{
                transform: `translateX(-${index * 100}%)`,
              }}
            >
              {loopedImages.map((img, i) => (
                <img
                  key={i}
                  src={img}
                  alt={`slide-${i}`}
                  className="w-full h-70 object-cover flex-shrink-0"
                />
              ))}
            </div>
          </div>
        </div>

        {/* STICKY HEADER  */}
        {expand && (
          <div className="sticky top-0 z-[9999] bg-orange-500 text-white px-4 py-6 text-center shadow-lg">
            <p className="text-xs font-semibold">{trackingText.sub}</p>
            <h2 className="text-lg mt-2 font-bold">{trackingText.main}</h2>
            {etaText && (
  <div className={`flex items-center justify-center gap-1 mt-1 text-sm text-white ${etaText.color}`}>
    <Timer size={14} />
    <span className="font-medium">{etaText.text}</span>
  </div>
)}
          </div>
        )}

        {/* MAP SECTION */}
        <div
          className={`transition-all duration-500 relative z-10 
              ${
                expand ? "" : "mt-4 ml-4 mr-4 bg-white rounded-xl max-w-md mx-4"
              }
              ${expand && !manualExpand ? "mt-10 ml-4 mr-4" : " mt-4"}
            `}
        >
          {/* CONTENT - Only wrap in flex container when NOT expanded */}
          {!expand ? (
            <div className="flex items-center px-4 py-2">
              {/* LEFT TEXT (SMALL MAP) */}
              <div className="w-1/2 pr-3">
                <p className="text-xs text-gray-500 font-semibold">
                  {trackingText.sub}
                </p>
                <h2 className="text-md mt-2 font-bold text-orange-600">
                  {trackingText.main}
                </h2>
                {etaText && (
  <div className={`flex items-center gap-1 mt-1 text-sm ${etaText.color}`}>
    <Timer size={14} />
    <span className="font-medium">{etaText.text}</span>
  </div>
)}
              </div>

              {/* MAP - SMALL */}
              <div className="relative overflow-hidden transition-all duration-500 rounded-xl w-1/2 h-28">
                <MapContainer
                  // center={mapCenter}
                  key="order-tracking-map"
                  zoom={13}
                  className="h-full w-full rounded-xl"
                  dragging={false}
                  scrollWheelZoom={false}
                  zoomControl={false}
                  attributionControl={false}
                  whenCreated={(map) => (mapRef.current = map)}
                >
                  {/* <MapResizer /> */}
                  <FitBounds bounds={bounds} />
                  <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                  {/* RESTAURANT */}
                  {pickupLat && pickupLng && (
                    <Marker
                      position={[pickupLat, pickupLng]}
                      icon={restaurantIcon}
                    >
                      <Popup>
                        <div className="text-sm font-semibold">
                          {restaurantName}
                        </div>
                      </Popup>
                    </Marker>
                  )}

                  {/* DUMMY DRIVER – ONLY WHEN NOT ASSIGNED */}
                  {showDummyDriver && dummyDriverPosition && (
                    <>
                      <Marker
                        position={dummyDriverPosition}
                        icon={driverIcon}
                      />

                      <Polyline
                        positions={dummyRoute}
                        pathOptions={{
                          color: "#2563eb",
                          weight: 3,
                          dashArray: "4 8", // dotted
                        }}
                      />
                    </>
                  )}

                  {/* REAL DRIVER – AFTER ASSIGN */}
                  {hasDriverLocation && (
                    <Marker
                      position={[driverLat, driverLng]}
                      icon={driverIcon}
                    />
                  )}

                  {/* REAL ROUTE – FOOD READY */}
                  {hasDriverLocation && isFoodReady && (
                    <Polyline
                      positions={realRoute}
                      pathOptions={{
                        color: "#2563eb",
                        weight: 4,
                        dashArray: "6 10",
                      }}
                    />
                  )}

                  {/* HOME */}
                  {homeLat && homeLng && (
                    <Marker position={[homeLat, homeLng]} icon={homeIcon}>
                      <Popup>
                        <div className="text-sm font-semibold">
                          {orderDetails?.customer_name}
                        </div>
                      </Popup>
                    </Marker>
                  )}
                </MapContainer>

                <button
                  onClick={handleMapToggle}
                  className="absolute z-[500] bg-white p-2 rounded-full shadow-md hover:bg-gray-50 bottom-2 right-2"
                >
                  <Maximize2 className="w-5 h-5" />
                </button>
              </div>
            </div>
          ) : (
            /* MAP - EXPANDED - No wrapper, full width */
            <div className="relative overflow-hidden transition-all duration-500 rounded-xl w-full h-[38vh]">
              <MapContainer
                // center={mapCenter}
                key="order-tracking-map"
                zoom={15}
                className="h-full w-full rounded-xl"
                dragging={true}
                scrollWheelZoom={true}
                zoomControl={false}
                attributionControl={false}
                whenCreated={(map) => (mapRef.current = map)}
              >
                {/* <MapResizer /> */}
                <FitBounds bounds={bounds} />
                <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                {/* RESTAURANT */}
                {pickupLat && pickupLng && (
                  <Marker
                    position={[pickupLat, pickupLng]}
                    icon={restaurantIcon}
                  >
                    <Popup>
                      <div className="text-sm font-semibold">
                        {restaurantName}
                      </div>
                    </Popup>
                  </Marker>
                )}

                {/* DUMMY DRIVER – ONLY WHEN NOT ASSIGNED */}
                {showDummyDriver && dummyDriverPosition && (
                  <>
                    <Marker position={dummyDriverPosition} icon={driverIcon} />

                    <Polyline
                      positions={dummyRoute}
                      pathOptions={{
                        color: "#2563eb",
                        weight: 3,
                        dashArray: "4 8", // dotted
                      }}
                    />
                  </>
                )}

                {/* REAL DRIVER – AFTER ASSIGN */}
                {hasDriverLocation && (
                  <Marker position={[driverLat, driverLng]} icon={driverIcon} />
                )}

                {/* REAL ROUTE – FOOD READY */}
                {hasDriverLocation && isFoodReady && (
                  <Polyline
                    positions={realRoute}
                    pathOptions={{
                      color: "#2563eb",
                      weight: 4,
                      dashArray: "6 10",
                    }}
                  />
                )}

                {/* HOME */}
                {homeLat && homeLng && (
                  <Marker position={[homeLat, homeLng]} icon={homeIcon}>
                    <Popup>
                      <div className="text-sm font-semibold">
                        {orderDetails?.customer_name}
                      </div>
                    </Popup>
                  </Marker>
                )}
              </MapContainer>

              <button
                onClick={handleMapToggle}
                className="absolute z-[500] bg-white p-2 rounded-full shadow-md hover:bg-gray-50 top-2 right-2"
              >
                <Minimize2 className="w-5 h-5" />
              </button>
            </div>
          )}
        </div>

        {/* DELIVERY PARTNER */}
        {hasDriverLocation && (
  <div className="bg-white max-w-md mt-4 rounded-xl shadow p-4 mx-4">
    <div className="flex items-center gap-3">
      <div className="w-12 h-12 rounded-full overflow-hidden bg-gray-200">
        <img
          src={driverData.image}
          alt="Driver"
          className="w-full h-full object-cover"
        />
      </div>

      <div className="flex-1">
        <p className="font-semibold">
          I'm {driverData.name}, your delivery partner
        </p>

        <p
          className={`text-sm transition-all duration-500 ${driverData.statusColor}`}
        >
          {driverData.message}
        </p>

        {etaText && (
  <div className={`flex items-center gap-1 mt-1 text-sm ${etaText.color}`}>
    <Timer size={14} />
    <span className="font-medium">{etaText.text}</span>
  </div>
)}

        {driverStatus === "successful" && (
          <span className="inline-block mt-1 h-2 w-2 rounded-full bg-green-500 animate-pulse"></span>
        )}
      </div>

      <a
        href={`tel:${driverData.phone}`}
        className="p-2 rounded-full border"
      >
        <Phone size={18} className="text-orange-600" />
      </a>
    </div>
  </div>
)}


        {/* STORE DISTANCE */}
        <div className="bg-white max-w-md mt-4 mx-4 rounded-xl p-4">
          <div className="flex items-start gap-3">
            <div className="p-2 rounded-full bg-gray-100">
              <ShieldCheck className="w-6 h-6 text-green-500" />
            </div>

            <p className="text-sm text-gray-700 flex-1">
              <strong>{restaurantName}</strong>{" "}
              {formattedStoreDistance && (
                <>
                  is <strong>{formattedStoreDistance}</strong> away.
                </>
              )}
              <br />
              <span className="text-orange-600">
                Learn about delivery partner safety
              </span>
            </p>

            <button
              onClick={() => setShowSafety(!showSafety)}
              className="p-3 rounded-full ml-auto bg-gray-100"
            >
              {showSafety ? <ArrowDown size={18} /> : <ArrowRight size={18} />}
            </button>
          </div>

          {/* Safety Details */}
          {showSafety && (
            <div className="mt-4 bg-gray-50 rounded-lg p-3 text-sm text-gray-700">
              <ul className="space-y-2">
                <li className="flex items-start gap-2">
                  <CheckCircle className="w-4 h-4 text-green-500 mt-[2px]" />
                  <span>Delivery partners are verified & trained</span>
                </li>

                <li className="flex items-start gap-2">
                  <CheckCircle className="w-4 h-4 text-green-500 mt-[2px]" />
                  <span>Contactless delivery option</span>
                </li>

                <li className="flex items-start gap-2">
                  <CheckCircle className="w-4 h-4 text-green-500 mt-[2px]" />
                  <span>Emergency support during delivery</span>
                </li>
              </ul>
            </div>
          )}
        </div>

        {/* DELIVERY INSTRUCTIONS */}

        {/* ADD INSTRUCTION (only if NOT submitted) */}
        {!instructionSubmitted && (
          <div className="bg-white max-w-md mt-4 mx-4 rounded-xl p-4 flex items-start gap-3">
            <div className="p-3 rounded-full bg-gray-100">
              <Mic size={18} />
            </div>

            <div className="flex-1">
              <p className="font-semibold">Add delivery instructions</p>
              <p className="text-sm text-gray-500">
                Help your delivery partner reach you
              </p>
            </div>

            <button
  onClick={() => {
    setInstructionOpen((prev) => {
      const next = !prev;

      if (next && !deliveryInstruction) {
        fetchDeliveryInstructions();
      }

      return next;
    });
  }}
  className="p-3 rounded-full bg-gray-100"
>
  {instructionOpen ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
</button>
          </div>
        )}

        {/* INSTRUCTION BODY (only if open & not submitted) */}
        {!instructionSubmitted && instructionOpen && deliveryInstruction && (
          <div className="bg-white max-w-md mt-2 mb-6 mx-4 rounded-xl shadow p-4 space-y-4">
            <div className="flex items-start gap-4">
              <div className="p-3 rounded-full bg-gray-100">
                {iconMap[deliveryInstruction.header.icon]}
              </div>
              <div>
                <p className="font-semibold">
                  {deliveryInstruction.header.title}
                </p>
                <p className="text-sm text-gray-500">
                  {deliveryInstruction.header.subtitle}
                </p>
              </div>
            </div>

            <hr />

            <div className="overflow-x-auto mini-scrollbar">
              <div className="flex flex-nowrap gap-3">
                {deliveryInstruction.sections.map((item) => {
                  const isSelected = selectedInstruction === item.id;

                  return (
                    <button
                      key={item.id}
                      onClick={() => {
                        setSelectedInstruction(item.id);
                        setCustomInstruction("");
                      }}
                      className={`min-w-[110px] h-[70px] text-left border rounded-xl px-3 py-2
                ${
                  isSelected
                    ? "border-orange-500 bg-orange-50"
                    : "border-gray-200 bg-white"
                }`}
                    >
                      <p className="font-semibold text-xs line-clamp-2">
                        {item.title}
                      </p>
                      {isSelected && (
                        <span className="block mt-1 text-[11px] font-semibold text-orange-600">
                          ✓ Selected
                        </span>
                      )}
                    </button>
                  );
                })}
              </div>
            </div>

            <textarea
              value={customInstruction}
              onChange={(e) => setCustomInstruction(e.target.value)}
              placeholder="Write custom instruction..."
              rows={2}
              className={`w-full text-sm border rounded-lg p-3 resize-none
        focus:ring-2 focus:ring-orange-500
        ${selectedInstruction ? "block" : "hidden"}`}
            />

            <div className="flex justify-center">
              <button
                onClick={handleSubmitInstruction}
                disabled={
                  submitting || (!customInstruction && !selectedInstruction)
                }
                className={`w-[180px] py-3 rounded-xl text-sm font-semibold
          ${
            submitting
              ? "bg-gray-300 text-gray-600"
              : "bg-orange-500 text-white hover:bg-orange-600"
          }`}
              >
                {submitting ? "Submitting..." : "Submit instructions"}
              </button>
            </div>
          </div>
        )}

        {/* SUBMITTED INSTRUCTION VIEW */}
        {instructionSubmitted && submittedInstruction && (
          <div className="bg-white max-w-md mt-4 mx-4 rounded-xl p-4 flex items-start gap-3">
            <div className="p-3 rounded-full bg-green-100">
              <CheckCircle size={18} className="text-green-600" />
            </div>

            <div className="flex-1">
              <p className="font-semibold">Delivery instruction sent</p>
              <p className="text-sm text-gray-700 mt-1">
                <strong>{submittedInstruction.title}</strong>
              </p>
              {submittedInstruction.message && (
                <p className="text-sm text-gray-500 mt-1">
                  “{submittedInstruction.message}”
                </p>
              )}
            </div>
          </div>
        )}

        {/* DELIVERY Details */}
        <div className="bg-white max-w-md mt-2 mb-6 mx-4 rounded-xl shadow p-4 space-y-4">
          <div className="flex items-start gap-4">
            <div className="p-3 rounded-full bg-gray-100">
              {iconMap[deliveryDetails.header.icon]}
            </div>
            <div>
              <p className="font-semibold">{deliveryDetails.header.title}</p>
              <p className="text-sm text-gray-500">
                {deliveryDetails.header.subtitle}
              </p>
            </div>
          </div>

          <hr />

          {/* SECTIONS */}
          {deliveryDetails.sections.map((item, index) => (
            <div key={item.id}>
              <div className="flex items-start gap-3">
                <div className="p-3 rounded-full bg-gray-100">
                  {iconMap[item.icon]}
                </div>
                <div>
                  <p className="font-semibold">{item.title}</p>
                  {item.description && (
                    <p className="text-sm text-gray-600">{item.description}</p>
                  )}
                </div>
              </div>

              {index !== deliveryDetails.sections.length - 1 && (
                <hr className="mt-4" />
              )}
            </div>
          ))}
        </div>

        {/* ORDER SUMMARY */}
        <div className="bg-white max-w-md mt-4 mb-6 mx-4 rounded-xl shadow p-4 space-y-4">
          {/* HEADER */}
          <div className="flex items-start gap-4">
            <div className="p-3 rounded-full bg-gray-100">
              <ClipboardList size={18} />
            </div>

            <div className="flex-1">
              <p className="font-semibold">Order Summary</p>

              <div className="flex items-center gap-2 mt-1">
                <p className="text-sm text-gray-500">Task ID: {taskId}</p>

                <button
                  onClick={handleCopy}
                  className="p-1 rounded hover:bg-gray-100"
                >
                  {copied ? (
                    <Check size={16} className="text-orange-600" />
                  ) : (
                    <Copy size={16} className="text-gray-600" />
                  )}
                </button>
              </div>
            </div>
          </div>

          {/* TOGGLE */}
         <button
  onClick={() => {
    setOpen((prev) => {
      const next = !prev;

      if (next && !orderSummaryLoaded) {
        fetchOrderDetails();
        setOrderSummaryLoaded(true);
      }

      return next;
    });
  }}
  className="w-full flex items-center justify-center px-4 py-3 gap-2 rounded-lg border text-sm font-medium hover:bg-gray-50"
>
  <span>View Order Summary</span>
  {open ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
</button>

          {/* BODY */}
{open && (
  <div className="space-y-4">
    {/* PRODUCTS */}
    {products.length > 0 && (
      <>
        <div className="space-y-3">
          {products.map((item) => (
  <div key={item.id} className="flex items-center gap-3">
    <img
      src={item.image || item1}
      alt={item.name}
      className="w-14 h-14 rounded-lg border object-cover"
    />

    <div className="flex-1">
      <p className="text-sm font-medium">{item.name}</p>
      <p className="text-xs text-gray-500">
        Qty: {item.qty} × ₹{item.unitPrice}
      </p>
    </div>

    <p className="text-sm font-semibold">
      ₹{item.itemTotal}
    </p>
  </div>
))}

        </div>

        <hr />
      </>
    )}

    {/* PRICING (always show) */}
    <div className="space-y-2 text-sm">
      <div className="flex justify-between">
        <span>Item total</span>
        <span>₹{pricing.subTotal}</span>
      </div>

      <div className="flex justify-between">
        <span>CGST</span>
        <span>₹{pricing.cgst}</span>
      </div>

      <div className="flex justify-between">
        <span>SGST</span>
        <span>₹{pricing.sgst}</span>
      </div>

      <div className="flex justify-between">
        <span>Delivery charge</span>
        <span className="text-orange-600">FREE</span>
      </div>

      <hr />

      <div className="flex justify-between font-semibold">
        <span>Paid via {pricing.paymentMode}</span>
        <span>₹{pricing.total}</span>
      </div>
    </div>

    <hr />

    {/* PAYMENT / ORDER STATUS (single source of truth) */}
    <div className="text-sm font-medium text-orange-600">
      Payment successful via {pricing.paymentMode} •{" "}
      {merchantStatus === "successful" || merchantStatus === "delivered"
        ? "Order delivered"
        : "Order confirmed"}
    </div>

    {/* EMPTY PRODUCTS INFO (optional UX) */}
    {products.length === 0 && (
      <p className="text-xs text-gray-400 text-center">
        Item details will appear once available
      </p>
    )}
  </div>
)}

        </div>

        {/* like service */}
        {showRatingSection && !ratingSubmitted && (
          <div className="bg-white max-w-md mt-4 mb-6 mx-4 rounded-xl p-4 pb-0">
            <div className="flex items-start gap-4 mb-4">
              <div className="p-3 rounded-full bg-gray-100">
                <ThumbsUp size={18} />
              </div>

              <div>
                <p className="font-semibold mb-1">
                  How was your delivery experience?
                </p>
                <p className="text-sm text-gray-500">
                  Rate your delivery partner
                </p>
              </div>
            </div>

            {/* RATING BUTTONS */}
            <div className="flex gap-2 mb-3">
              {[1, 2, 3, 4, 5].map((star) => (
                <button
                  key={star}
                  onClick={() => setDriverRating(star)}
                  className={`flex-1 py-2 rounded-lg text-sm font-semibold border
            ${
              driverRating === star
                ? "bg-orange-500 text-white border-orange-500"
                : "bg-white text-gray-600"
            }`}
                >
                  {star} ⭐
                </button>
              ))}
            </div>

            {/* MESSAGE */}
            <textarea
              value={customerMessage}
              onChange={(e) => setCustomerMessage(e.target.value)}
              placeholder="Write a short feedback (optional)"
              rows={2}
              className="w-full text-sm border rounded-lg p-3 resize-none
      focus:outline-none focus:ring-2 focus:ring-orange-500"
            />

            {/* ACTION BUTTONS */}
            <div className="-mx-4 bg-gray-100 pt-[3px] flex gap-[3px] mt-4">
              <button
                onClick={() => setRatingSubmitted(true)}
                className="w-1/2 py-3 text-sm text-orange-500 font-medium bg-white rounded-bl-xl"
              >
                May be later
              </button>

              <button
                onClick={submitDeliveryRating}
                disabled={ratingSubmitting}
                className={`w-1/2 py-3 text-sm font-medium rounded-br-xl
          ${
            ratingSubmitting
              ? "bg-gray-300 text-gray-600"
              : "bg-orange-500 text-white"
          }`}
              >
                {ratingSubmitting ? "Submitting..." : "Submit"}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
